import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseSettings;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import { IfFeature, Page, featureOn } from '@instructure/quiz-core';
import t from '@instructure/quiz-i18n/format-message';
import AllowClearMCSelection from './components/AllowClearMCSelection';
import ChoiceElimination from './components/ChoiceElimination';
import IpFilter from './components/IpFilter';
import OneQuestionAtATime from './components/OneQuestionAtATime';
import ShuffleQuestions from './components/ShuffleQuestions';
import ShuffleAnswers from './components/ShuffleAnswers';
import StudentAccessCode from './components/StudentAccessCode';
import Timer from './components/Timer';
import Calculator from './components/Calculator';
import ResultsFeedback from './components/ResultsFeedback';
import DefaultRceSettings from './components/DefaultRceSettings';
import DisableDocumentAccess from './components/DisableDocumentAccess';
import DetectMultipleSessions from './components/DetectMultipleSessions';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';

// These are used in a <ul> below, so need keys
export var SDKSettings = [jsx(ShuffleQuestions, {
  key: "shuffle_setting"
}), jsx(IfFeature, {
  name: "shuffle_answers",
  key: "shuffle_answers_setting"
}, jsx(ShuffleAnswers, null)), jsx(OneQuestionAtATime, {
  key: "oqaat_setting"
}), jsx(StudentAccessCode, {
  key: "accesscode_setting"
}), jsx(Timer, {
  key: "timer_setting"
}), jsx(IfFeature, {
  name: "detect_multiple_sessions",
  key: "detect_multiple_sessions_setting"
}, jsx(DetectMultipleSessions, null)), jsx(IpFilter, {
  key: "ipfilter_setting"
}), jsx(IfFeature, {
  name: "on_screen_calculator",
  key: "calculator_setting"
}, jsx(Calculator, null)), jsx(AllowClearMCSelection, {
  key: "allow_clear_mc_selection_setting"
}), jsx(IfFeature, {
  name: "choice_elimination",
  key: "choice_elimination_setting"
}, jsx(ChoiceElimination, null)), jsx(IfFeature, {
  name: "results_feedback",
  key: "results_feedback"
}, jsx(ResultsFeedback, null)), jsx(IfFeature, {
  name: "default_rce_settings",
  key: "default_rce_settings"
}, jsx(DefaultRceSettings, null)), jsx(IfFeature, {
  name: "document_access_settings",
  key: "document_access_settings"
}, jsx(DisableDocumentAccess, null))];
export function SDKSettingsFunc(ipFilterProps) {
  return [jsx(ShuffleQuestions, {
    key: "shuffle_setting"
  }), jsx(IfFeature, {
    name: "shuffle_answers",
    key: "shuffle_answers_setting"
  }, jsx(ShuffleAnswers, null)), jsx(OneQuestionAtATime, {
    key: "oqaat_setting"
  }), jsx(StudentAccessCode, {
    key: "accesscode_setting"
  }), jsx(Timer, {
    key: "timer_setting"
  }), jsx(IfFeature, {
    name: "detect_multiple_sessions",
    key: "detect_multiple_sessions_setting"
  }, jsx(DetectMultipleSessions, null)), jsx(IpFilter, Object.assign({
    key: "ipfilter_setting"
  }, ipFilterProps)), jsx(IfFeature, {
    name: "on_screen_calculator",
    key: "calculator_setting"
  }, jsx(Calculator, null)), jsx(AllowClearMCSelection, {
    key: "allow_clear_mc_selection_setting"
  }), jsx(IfFeature, {
    name: "choice_elimination",
    key: "choice_elimination_setting"
  }, jsx(ChoiceElimination, null)), jsx(IfFeature, {
    name: "results_feedback",
    key: "results_feedback"
  }, jsx(ResultsFeedback, null)), jsx(IfFeature, {
    name: "default_rce_settings",
    key: "default_rce_settings"
  }, jsx(DefaultRceSettings, null)), jsx(IfFeature, {
    name: "disable_document_access",
    key: "document_access_settings"
  }, jsx(DisableDocumentAccess, null))];
}
var BaseSettings = /*#__PURE__*/function (_Component) {
  function BaseSettings() {
    _classCallCheck(this, BaseSettings);
    return _callSuper(this, BaseSettings, arguments);
  }
  _inherits(BaseSettings, _Component);
  return _createClass(BaseSettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeQuizId = this.props.activeQuizId;
      this.props.quizBuildingSession({
        activeQuizId: activeQuizId
      });
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps) {
      var activeQuizId = nextProps.activeQuizId;
      if (this.props.activeQuizId !== activeQuizId) {
        this.props.quizBuildingSession({
          activeQuizId: activeQuizId
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Page, null, jsx("div", {
        css: this.props.styles.page
      }, jsx(Heading, {
        level: "h1"
      }, t('Settings')), this.props.alertComponent, jsx("ul", {
        css: this.props.styles.list
      }, this.props.children)));
    }
  }]);
}(Component);
_BaseSettings = BaseSettings;
_defineProperty(BaseSettings, "displayName", 'Settings');
_defineProperty(BaseSettings, "componentId", "Quizzes".concat(_BaseSettings.displayName));
_defineProperty(BaseSettings, "propTypes", {
  activeQuizId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  alertComponent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  quizBuildingSession: PropTypes.func.isRequired,
  styles: PropTypes.object
});
_defineProperty(BaseSettings, "defaultProps", {
  children: featureOn('named_ip_filters') ? SDKSettingsFunc({}) : SDKSettings,
  alertComponent: null
});
export var Settings = withStyleOverrides(generateStyle, generateComponentTheme)(BaseSettings);
export default Settings;